<template>
  <div class="wrap">
    <van-overlay :show="show" z-index="10" @click="show = false">
      <img class="shareimg" src="../../assets/img/rshareIcon.png" alt="" />
    </van-overlay>
    <div class="pagebg">
      <img class="title" src="../../assets/img/sheretitle.png" alt="" />
      <div style="text-align: center;color: rgba(253, 219, 140, 1);font-size:13px ;">
        好友开通会员 立返20%现金
      </div>
      <div class="contentInfo">
        <div class="infoblackbox">
          <div class="tx">
            <img :src="userinfo.headimgUrl" alt="" />
            <span>{{ userinfo.nickName }}</span>
          </div>
          <div class="desc">
            <div class="n">
              <div class="row">已成功邀请</div>
              <div class="row">{{ inviteNum }}人</div>
            </div>
            <div class="n">
              <div class="row">累计赚取现金</div>
              <div class="row">{{ incomeAmount }}</div>
            </div>
          </div>
          <div class="row">分享至钱币群，朋友圈，坐等现金到账~</div>
        </div>
        <van-button
          @click="show = true"
          class="sharebtn"
          block
          round
          color="linear-gradient(to right, #f5eddc, #eabd59)"
          size="small"
          >立即分享</van-button
        >
      </div>

      <div class="reslist">
        <van-tabs @change="change" v-model="activeName">
          <van-tab title="收益排行榜" name="1"></van-tab>
          <van-tab title="我的收益" name="2"></van-tab>
        </van-tabs>
        <!-- 收益排行榜 -->
        <div v-if="activeName == 1" class="incomeRnak">
          <div class="header">
            <div class="th">名次</div>
            <div class="th fl2">用户</div>
            <div class="th fl3">邀请人数</div>
            <div class="th fl3">总收益</div>
          </div>
          <div v-for="(item, index) in weekList" :key="index" class="incomebody">
            <div class="td">{{ index + 1 }}</div>
            <div class="td fl2">
              <img :src="item.inviteHeadImgUrl" alt="" />{{ replaceKey(item.inviteNickName) }}
            </div>
            <div class="td fl3">{{ item.inviteNum }}</div>
            <div class="td fl3">{{ item.incomeMoney }}</div>
          </div>
        </div>

        <div v-if="activeName == 2" class="incomeRnak">
          <template v-if="userList.length > 0">
            <div class="header">
              <div class="th">序号</div>
              <div class="th fl2">用户</div>
              <div class="th fl3">开通会员类型</div>
              <div class="th fl3">赚取现金</div>
            </div>
            <div v-for="(item, index) in userList" :key="index" class="incomebody">
              <div class="td">{{ index + 1 }}</div>
              <div class="td fl2">
                <img :src="item.inviteHeadImgUrl" alt="" />{{ replaceKey(item.inviteNickName) }}
              </div>
              <div class="td fl3">{{ viptype(item.vipCategory) }}</div>
              <div class="td fl3">{{ item.incomeMoney }}</div>
            </div>
          </template>
          <div class="noContent" v-if="userList.length == 0">
            <img src="../../assets/img/noContent.png" alt="" />
            <div style="margin-bottom:5px">您暂时还没有成功邀请相关好友</div>
            <div>快点击上方"立即分享"去邀请吧~</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUserStatIncomeInfo,
  getWeekUserIncomeInfo,
  getUserIncomeInfo,
  wxuser,
} from '@/api/base';
import { viptype, replaceKey } from '@/utils/index';
export default {
  name: '',
  components: {},
  data() {
    return {
      activeName: 1,
      userinfo: null,
      incomeAmount: null,
      inviteNum: null,
      weekList: [],
      userList: [],
      show: false,
    };
  },
  created() {
    this.init();
    console.log(this);
  },
  mounted() {
    let that = this;
    setTimeout(function() {
      wx.ready(function() {
        wx.updateAppMessageShareData({
          title: '太方便！我正在使用一尘网手机发帖，手机上图', // 分享标题
          desc: '数万藏友使用，评分高，简单好用，无需下载关注即用，快去关注使用吧~', // 分享描述
          link: location.origin + `/#/share?icoi=${that.userinfo.openId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: '太方便！我正在使用一尘网手机发帖，手机上图', // 分享标题
          desc: '数万藏友使用，评分高，简单好用，无需下载关注即用，快去关注使用吧~', // 分享描述
          link: location.origin + `/#/share?icoi=${that.userinfo.openId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
      });
    }, 1000);
  },
  methods: {
    viptype,
    replaceKey,
    init() {
      wxuser().then(res => {
        console.log(res);
        this.userinfo = res.data.wxUser;
      });
      getUserStatIncomeInfo()
        .then(res => {
          console.log(res);
          this.incomeAmount = res.data.incomeAmount;
          this.inviteNum = res.data.inviteNum;
          return getWeekUserIncomeInfo();
        })
        .then(res => {
          this.weekList = res.data;
          return getUserIncomeInfo();
        })
        .then(res => {
          this.userList = res.data;
        });
    },
    change(e) {
      console.log(e);
    },
  },
};
</script>
<style scoped>
.wrap {
  width: 100%;
  min-height: 100vh;
  background: url('../../assets/img/sharebg.png') no-repeat;
  box-sizing: border-box;
  background-size: 100% 100%;
  position: relative;
  /* background: rgba(254, 82, 24, 1); */
}
.wrap .shareimg {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  width: 273px;
  background: transparent;
  /* z-index: 12; */
}
.wrap .pagebg {
  width: 100%;
  min-height: 100vh;
  padding-top: 24px;
}

.wrap .pagebg .title {
  display: block;
  width: 59%;
  margin: 0 auto;
}
.wrap .pagebg .contentInfo {
  margin-top: 33px;

  background: url('../../assets/img/contentbox.png') no-repeat;
  background-size: 100% 100%;
  padding: 17px 73px 63px 73px;
  margin-bottom: 17px;
}
.wrap .pagebg .contentInfo .infoblackbox {
  width: 100%;
  opacity: 1;
  border-radius: 10px;
  background: linear-gradient(130.85deg, rgba(74, 85, 96, 1) 0%, rgba(25, 42, 58, 1) 100%);
  box-shadow: 0px 30px 40px 0px rgba(158, 44, 4, 0.3);
  position: relative;
  padding-bottom: 14px;
  margin-bottom: 10px;
}
.wrap .pagebg .contentInfo .infoblackbox .tx {
  position: relative;
  text-align: center;
  margin-top: -5px;
}
.wrap .pagebg .contentInfo .infoblackbox .tx img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 50%;
  top: -20px;
  border-radius: 50%;
  transform: translateX(-50%);
  /* transform: translateY(-50%); */
}
.wrap .pagebg .contentInfo .infoblackbox .tx span {
  opacity: 1;
  text-shadow: 0px 20px 20px 0px rgba(176, 55, 13, 0.2);
  /** 文本1 */
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.wrap .pagebg .contentInfo .infoblackbox .desc {
  display: flex;
  justify-content: space-around;
}
.wrap .pagebg .contentInfo .infoblackbox .desc .n .row,
.wrap .pagebg .contentInfo .infoblackbox .row {
  text-shadow: 0px 20px 20px 0px rgba(176, 55, 13, 0.2);
  /** 文本1 */
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  color: rgba(253, 219, 140, 1);
  text-align: center;
  line-height: 20px;
  margin-bottom: 9px;
}
.wrap .pagebg .contentInfo .sharebtn {
  width: 60%;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(152, 62, 17, 1);
  margin: 0 auto;
}
.wrap .pagebg .reslist {
  padding: 0 15px;
  box-sizing: border-box;
}
.wrap .pagebg .reslist .incomeRnak {
  padding: 0 15px;
  padding-top: 16px;
  overflow-y: auto;
  height: 35vh;
}
.wrap .pagebg .reslist .incomeRnak .header {
  display: flex;
  margin-bottom: 5px;
}
.wrap .pagebg .reslist .incomeRnak .header .th {
  flex: 1;
  text-shadow: 0px 20px 20px 0px rgba(176, 55, 13, 0.2);
  /** 文本1 */
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  color: rgba(253, 219, 140, 1);
  text-align: center;
  line-height: 17px;
}

.wrap .pagebg .reslist .incomebody {
  display: flex;
}
.wrap .pagebg .reslist .incomebody .td {
  text-shadow: 0px 20px 20px 0px rgba(176, 55, 13, 0.2);
  /** 文本1 */
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  line-height: 17px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.wrap .pagebg .reslist .incomebody .td.r {
  justify-content: flex-end;
}
.wrap .pagebg .reslist .incomebody .td img {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
}
.wrap .pagebg .reslist .fl2 {
  flex: 2;
}
.wrap .pagebg .reslist .fl3 {
  flex: 3;
}
.wrap .noContent {
  width: 100%;
  padding-top: 43px;
  text-shadow: 0px 20px 20px 0px rgba(176, 55, 13, 0.2);
  /** 文本1 */
  font-size: 13px;
  font-weight: 400;
  color: rgba(229, 229, 229, 1);
  text-align: center;
  line-height: 18px;
}
.wrap .noContent img {
  display: block;
  width: 40%;
  margin: 0 auto;
  margin-bottom: 29px;
}
</style>
